import { t } from '../../utilities/translator';

const GroupModalStep2 = ({ nextClick, backClick }) => {
  return (
    <>
      <div className="flex flex-col gap-6 pb-8 gbm-main">
        <h3 className="gb-title">{t('groupBookingTutorial.modalStep2Title')}</h3>
        <div className="gb-badge flex items-center">
          <div className="gbb-btns-tutorial flex items-center gap-5">
            <button className="move-btn move-btn--fake move-btn--primary move-btn--large rounded">{t('groupBookingTutorial.bookNow')}</button>
            <span className="gbm-btn gbm-btn--fake flex items-center gap-1 relative">
              <i className="ri-team-line" />
              <span>{t('groupBookingTutorial.bookWithFriends')}</span>
              <span className="gbb-hand-icon" />
            </span>
          </div>
        </div>
        <ul className="gb-step-list flex flex-col gap-4 pb-3">
          <li className="flex items-center gap-2">
            <b className="flex items-center justify-center">1</b>
            <span>{t('groupBookingTutorial.modalStep2Bullet1')}</span>
          </li>
          <li className="flex items-center gap-2">
            <b className="flex items-center justify-center">2</b>
            <span>{t('groupBookingTutorial.modalStep2Bullet2')}</span>
          </li>
          <li className="flex items-center gap-2">
            <b className="flex items-center justify-center">3</b>
            <span>{t('groupBookingTutorial.modalStep2Bullet3')}</span>
          </li>
        </ul>
      </div>
      <div className="flex gap-4 mt-auto justify-between gbm-foot">
        <button className="move-btn move-btn--large rounded" onClick={backClick}><i className="ri-arrow-left-line" />{t('groupBookingTutorial.back')}</button>
        <div className="flex items-center gap-1 gbmf-dots">
          <span />
          <span className="active" />
        </div>
        <button className="move-btn move-btn--primary move-btn--large rounded" onClick={nextClick}>{t('groupBookingTutorial.gotIt')}<i className="ri-check-line" /></button>
      </div>
    </>
  );
};

export default GroupModalStep2;
